import React from "react";
import { useNavigate } from "react-router-dom";
import ThankyouBanner from "../assets/images/ThankYouBanner2.png";
import ThankyouBannerMobile from "../assets/images/ThankyouBannerMobile.png";

const ThankYouPage = () => {
  const navigate = useNavigate();

  return (
    <div
      className="h-screen w-screen bg-cover bg-center flex items-center justify-start relative"
      // Default → Mobile background
      style={{
        backgroundImage: `url(${ThankyouBannerMobile})`,
      }}
    >
      {/* Desktop Background */}
      <div
        className="hidden md:block absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${ThankyouBanner})`,
        }}
      ></div>

      {/* Content */}
      <div className="relative p-2 md:p-16 rounded-lg text-left ml-6 md:ml-20 bg-opacity-60">
        <p className="text-lg md:text-2xl text-[#c55b12] font-bold mb-6 font-inter lg:max-w-md 3xl:max-w-xl">
          Thank you for reaching out! <br /> One of our representatives will get
          back to you shortly.
        </p>

        <div className="xs:block sm:flex gap-5 ">
          <button
            onClick={() => window.open("/aura brochure_view.pdf", "_blank")}
            className="px-6 py-3 bg-[#c55b12] text-white rounded-2xl transition-shadow duration-300 font-inter hover:shadow-lg xs:my-2 sm:my-0"
          >
            Download Brochure
          </button>

          <button
            onClick={() => navigate("/")}
            className="px-6 py-3 bg-[#c55b12] text-white rounded-2xl transition-shadow duration-300 font-inter hover:shadow-lg"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
